var map = {
	"./icon_caiwu@2x.png": "./src/assets/menu1/icon_caiwu@2x.png",
	"./icon_del-16@2x(1).png": "./src/assets/menu1/icon_del-16@2x(1).png",
	"./icon_del-16@2x.png": "./src/assets/menu1/icon_del-16@2x.png",
	"./icon_dingdan@2x.png": "./src/assets/menu1/icon_dingdan@2x.png",
	"./icon_hou_disable@2x.png": "./src/assets/menu1/icon_hou_disable@2x.png",
	"./icon_hou_hov@2x.png": "./src/assets/menu1/icon_hou_hov@2x.png",
	"./icon_hou_nor@2x.png": "./src/assets/menu1/icon_hou_nor@2x.png",
	"./icon_kefu@2x.png": "./src/assets/menu1/icon_kefu@2x.png",
	"./icon_qian_disable@2x.png": "./src/assets/menu1/icon_qian_disable@2x.png",
	"./icon_qian_hov@2x.png": "./src/assets/menu1/icon_qian_hov@2x.png",
	"./icon_qian_nor@2x.png": "./src/assets/menu1/icon_qian_nor@2x.png",
	"./icon_shangcheng@2x.png": "./src/assets/menu1/icon_shangcheng@2x.png",
	"./icon_shangyibu@2x.png": "./src/assets/menu1/icon_shangyibu@2x.png",
	"./icon_shanpin@2x.png": "./src/assets/menu1/icon_shanpin@2x.png",
	"./icon_shouqi@2x(1).png": "./src/assets/menu1/icon_shouqi@2x(1).png",
	"./icon_shouqi@2x.png": "./src/assets/menu1/icon_shouqi@2x.png",
	"./icon_xitong@2x.png": "./src/assets/menu1/icon_xitong@2x.png",
	"./icon_yingxiao@2x.png": "./src/assets/menu1/icon_yingxiao@2x.png",
	"./icon_yonghuguanli@2x.png": "./src/assets/menu1/icon_yonghuguanli@2x.png",
	"./icon_zhankai@2x(1).png": "./src/assets/menu1/icon_zhankai@2x(1).png",
	"./icon_zhankai@2x.png": "./src/assets/menu1/icon_zhankai@2x.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/menu1 sync recursive ^\\.\\/.*\\.png$";